import React, { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import storePersist from '../../redux/storePersist';
import * as R from "ramda"
import { programs } from '../../redux/programs/action';
import { useAppDispatch } from '../../hooks/hooks';
import { selectMembershipCreatedItem } from '../../redux/membership/selector';
import { membershipSubscriptions } from '../../redux/membership-subscriptions/action';
import { membership } from '../../redux/membership/action';


export default function SubscribeDetailsModal({ membershipdetails }: any) {

  const dispatch = useAppDispatch();
  const memberprograms = useSelector(selectMembershipCreatedItem)
  const statesItems = storePersist?.get("states")?.current?.items;
  const countriesItems = storePersist?.get("countries")?.current?.items;
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const [userCreatedSuccess, setUserCreatedSuccess] = useState(false);
  const [selectedMembership, setSelectedMembership] = useState<any>({});
  const resetForm = () => {
    setSelectedMembership({
      Login: {
        Phone: "",
        Email: ""
      },
      UserProfile: {
        FirstName: "",
        LastName: "",
        PersonTitle: ""
      },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
      },
      Account: {
        IsPersonAccount: true,
        Name: "",
        TypeId: ""
      },
      PrimaryAddress: {
        address1: "",
        address2: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      }
    });
  };


  useEffect(() => {
    if (userCreatedSuccess) {
      dispatch(membershipSubscriptions.resetAction({ actionType: 'create' }))
      dispatch(membershipSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/membership-subscriptions`,
        entity: 'subscription',
        jsonData: {
          Context: {},
          Records: [
            {
              "Email": selectedMembership?.Login?.Email,
              "PhoneNumber": selectedMembership?.Login?.Phone,
              "OwnerType": "ONEMembership",
              "OwnerId": membershipdetails?.ONEMemberships?.[0]?.EntityInfo?.Id,
              "ONEMembershipPolicyId": membershipdetails?.Id,
              "IsExistingUser": selectedMembership?.IsExistingUser || false,
            }
          ]
        }
      }));
      resetForm();
      dispatch(programs.resetAction({ actionType: 'create' }));
      setUserCreatedSuccess(false); // prevent repeated firing
    }
  }, [userCreatedSuccess]);


  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      "Login": {
        "Phone": selectedMembership?.Login?.Phone,
        "Email": selectedMembership?.Login?.Email,
      },

      "UserProfile": {
        "FirstName": selectedMembership?.UserProfile?.FirstName,
        "LastName": "",
        "PersonTitle": ""
      },
      "ONEUserInfo": {
        "Biography": null,
        "PhotoUrl": null,
        "IsONEUserVerified": true,
        "StartupName": null,
        "YearsInOperation": "",
        "IsTechFirstInnovation": true,
        "StageOfTheStartup": null,
        "Sector": null,
        "WebsiteLink": null,
        "utm_source": null,
        "utm_medium": null,
        "utm_campaign": null,
        "utm_term": null,
        "utm_content": null
      },

      "Account": {
        "IsPersonAccount": true,
        "Name": selectedMembership?.Login?.Email,
        "TypeId": 440
      },

      "PrimaryAddress": {
        "address1": selectedMembership?.PrimaryAddress?.address1,
        "address2": selectedMembership?.PrimaryAddress?.address2,
        "city": selectedMembership?.PrimaryAddress?.city,
        "CountryId": selectedMembership?.PrimaryAddress?.CountryId,
        "StateProvinceId": selectedMembership?.PrimaryAddress?.StateProvinceId,
        "ZipPostalCode": selectedMembership?.PrimaryAddress?.ZipPostalCode,
      }

    }

    if (!selectedMembership?.IsExistingUser) {
      await dispatch(membership.resetAction({ actionType: 'create' }))
      await dispatch(membership.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'membership',
        jsonData: {
          records: [data]
        }
      }));
      setUserCreatedSuccess(true); // ✅ trigger subscription effect
    } else {
      dispatch(membershipSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/membership-subscriptions`,
        entity: 'programSubscriptions',
        jsonData: {
          Context: {},
          Records: [
            {
              "Email": selectedMembership?.Email,
              "PhoneNumber": selectedMembership?.Phone,
              "OwnerType": "ONEMembership",
              "OwnerId": membershipdetails?.ONEMemberships?.[0]?.EntityInfo?.Id,
              "ONEMembershipPolicyId": membershipdetails?.Id,
              "IsExistingUser": selectedMembership?.IsExistingUser || false,
            }
          ]
        }
      }));
      resetForm();
    }

  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedMembership({ ...selectedMembership, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedMembership({ ...selectedMembership, [field]: event })

  }

  return (
    <div className="w-full flex justify-center items-start  mt-10 rounded-2xl bg-white">
      <div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
        <div className="text-2xl text-primary font-bold py-5">
          Membership Subscription Form
        </div>
        <div className=" w-full px-3 font-bold space-y-2">
          <div className=" w-full px-3 font-bold space-y-2">
            <div className=" w-full pt-2">
              <div className="font-normal ">
                <input
                  type="checkbox"
                  name="IsExistingUser"
                  checked={selectedMembership?.IsExistingUser || false}
                  onChange={(event) => {
                    handleChange(event.target.checked, 'IsExistingUser');
                  }}
                  className="mr-2 w-4 h-4"
                />
                <label htmlFor="IsExistingUser" className="text-base">
                  Are you already registered?
                </label>
              </div>
            </div>
          </div>
          {!selectedMembership?.IsExistingUser && (
            <div className="flex flex-row space-x-2 ">
              <div className=" w-full pt-2">
                <div className="font-normal ">
                  <input
                    required
                    type="text"
                    name={"FirstName"}
                    placeholder="Name"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'UserProfile.FirstName',
                        selectedMembership?.UserProfile
                      );

                    }}
                    value={selectedMembership?.UserProfile?.FirstName} />
                </div>
              </div>
            </div>
          )}
          {selectedMembership?.IsExistingUser && (
            <div className="flex flex-col space-y-2">

              {!selectedMembership?.Email && !selectedMembership?.Phone && (
                <label className="text-sm text-gray-700 font-medium mb-2">
                  Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                </label>
              )}

              <div className="flex flex-row space-x-2">

                {!selectedMembership?.Phone && (
                  <div className="w-full">
                    <div className="border-0 font-normal">
                      <label className="text-xs text-gray-600 pl-1">Email</label>
                      <input
                        required
                        type="email"
                        name="Email"
                        placeholder="Email"
                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                        onChange={(event) => {
                          handleChange(event.target.value, 'Email');
                        }}
                        value={selectedMembership?.Email}
                      />
                    </div>
                  </div>
                )}

                {!selectedMembership?.Email && (
                  <div className="w-full">
                    <div className="border-0 font-normal">
                      <label className="text-xs text-gray-600 pl-1">Phone Number</label>
                      <input
                        required
                        maxLength={10}
                        type="text"
                        name="Phone"
                        placeholder="Phone Number"
                        pattern="\d{10}"
                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                        onChange={(event) => {
                          handleChange(event.target.value.replace(/\D/g, ''), 'Phone');
                        }}
                        value={selectedMembership?.Phone}
                      />
                      {selectedMembership?.Phone?.length > 0 &&
                        selectedMembership?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">
                            Please enter a valid number.
                          </span>
                        )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          )}

          {!selectedMembership?.IsExistingUser && (
            <div className="flex flex-row space-x-2 ">
              <div className=" w-full">

                <div className="border-0 font-normal">
                  <input
                    required
                    type="email"
                    name={"Email"}
                    placeholder="Email"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'Login.Email',
                        selectedMembership?.Login
                      );
                    }}
                    value={selectedMembership?.Login?.Email} />
                </div>
              </div>
              <div className=" w-full">

                <div className="border-0 font-normal">
                  <input
                    required
                    maxLength={10}
                    type="text"
                    name={"Phone"}
                    placeholder="Phone Number"
                    pattern="\d{10}"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value.replace(/\D/g, ''),
                        'Login.Phone',
                        selectedMembership?.Login
                      );
                    }}
                    value={selectedMembership?.Login?.Phone} />
                  {selectedMembership?.Phone && selectedMembership?.Phone?.length < 10 && (
                    <span className="text-red-600 text-xs">
                      Please enter a valid number.
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          {!selectedMembership?.IsExistingUser && (
            <div className="flex flex-row space-x-2 ">
              <div className=" w-full">

                <div className="border-0 font-normal">
                  <input
                    required
                    type="text"
                    name={"address1"}
                    placeholder="Building"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'PrimaryAddress.address1',
                        selectedMembership?.PrimaryAddress
                      );
                    }}
                    value={selectedMembership?.PrimaryAddress?.address1} />
                </div>
              </div>
              <div className=" w-full">
                <div className="border-0 font-normal">
                  <input
                    required
                    type="text"
                    name={"address2"}
                    placeholder="Locality"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'PrimaryAddress.address2',
                        selectedMembership?.PrimaryAddress
                      );
                    }}
                    value={selectedMembership?.PrimaryAddress?.address2} />
                </div>
              </div>
            </div>
          )}
          {!selectedMembership?.IsExistingUser && (

            <div className="flex flex-row space-x-2 ">
              <div className=" w-full">

                <div className="border-0 font-normal">
                  <input
                    required
                    type="text"
                    name={"city"}
                    placeholder="City"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'PrimaryAddress.city',
                        selectedMembership?.PrimaryAddress
                      );
                    }}
                    value={selectedMembership?.PrimaryAddress?.city} />
                </div>
              </div>
              <div className=" w-full">
                <div className="border-0 font-normal">
                  <input
                    required
                    type="text"
                    name={"ZipPostalCode"}
                    placeholder="Pincode"
                    className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                    onChange={(event) => {
                      handleInnerFormChange(
                        event.target.value,
                        'PrimaryAddress.ZipPostalCode',
                        selectedMembership?.PrimaryAddress
                      );
                    }}
                    value={selectedMembership?.PrimaryAddress?.ZipPostalCode} />
                </div>
              </div>
            </div>
          )}
          {!selectedMembership?.IsExistingUser && (
            <div className="flex flex-row space-x-2">

              <div className="w-full">
                <div className="border-0 font-normal">
                  <select
                    required
                    name="country"
                    className="w-full py-3 px-3 border-b-2 border-black text-base"
                    onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                      selectedMembership?.PrimaryAddress
                    )}
                    value={selectedMembership?.PrimaryAddress?.CountryId || ''}
                  >
                    <option value="" disabled hidden>Select Country</option>

                    {countriesItems.map((country: any) => (
                      <option key={country?.Id} value={country?.Id}>{country?.Name}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="w-full">
                <div className="border-0 font-normal">
                  <select
                    required
                    name="StateProvinceId"
                    className="w-full py-3 px-3 border-b-2 border-black text-base"
                    onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                      selectedMembership?.PrimaryAddress
                    )}
                    value={selectedMembership?.PrimaryAddress?.StateProvinceId || ''} >
                    <option value="" disabled hidden>Select State</option>
                    {statesItems?.length > 0 ? (
                      statesItems.map((state, index) => (
                        <option key={index} value={state.Id}>
                          {state.Name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>No states available</option>
                    )}
                  </select>
                </div>
              </div>
            </div>
          )}

        </div>
        <div className={`${isButtonLoading ? 'bg-primary/70' : 'bg-primary'} px-5 flex w-full flex-row items-center justify-center mt-5 mb-10 rounded-lg`}>
          <div onClick={handleSubmit} className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer">
            Subscribe
            <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
              <RotatingLines
                visible={true}
                width={'20'}
                strokeColor="#fff"
                strokeWidth="6"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

